import { TBusinessTipState } from './types';

export function getParticipantsList(state: TBusinessTipState) {
  return state.participantsList;
}

export function getForeignParticipantsList(state: TBusinessTipState) {
  return state.foreignParticipantsList;
}
